<template>
	<div id="" ref="" style="display:grid; grid-template-columns:auto auto; border:1px solid #cccccc;">
		<div style="border-right:1px solid #cccccc; display:grid; grid-template-rows:270px 270px;">
			<div style="border-bottom:1px solid #cccccc; display:grid; grid-template-columns:auto auto auto;">
				<input type="file" id="idImgFile1" ref="idImgFile1" style="display:none;" accept=".jpg,.png" @change="onImgChange"/>
				<div style="float:left; width:252px; height:252px; margin-left:10px; margin-top:10px; border:1px solid #bbbbbb; position:relative; cursor:pointer;" @click="onFileClick1">
					<img ref="idUserImg1" style="float:left; border:0px solid red;">
					<div ref="idUserNte1" style="position:absolute; width:100%; height:100%; line-height:250px; text-align:center;">{{getLangText(selText1)}}</div>
				</div>
				<div class="NButton DIVNoSelect" style="float:left; width:70px; height:30px; margin-left:25px; margin-top:145px;" @click="onCreateClick1">{{getLangText("生成")}}</div>
				<div style="float:left; width:252px; height:252px; margin-left:25px; margin-top:10px; margin-right:10px; border:1px solid #bbbbbb; position:relative; cursor:pointer;">
					<div ref="idRstImg1" style="float:left; width:100%; height:100%; border:0px solid red;"></div>
					<div ref="idRstNte1" style="position:absolute; width:100%; height:100%; line-height:250px; text-align:center;">{{getLangText("效果图")}}</div>
				</div>
			</div>
			<div style="display:grid; grid-template-columns:auto auto auto;" ref="idImgPan2">
				<input type="file" id="idImgFile2" ref="idImgFile2" style="display:none;" accept=".jpg,.png" @change="onImgChange"/>
				<div style="float:left; width:252px; height:252px; margin-left:10px; margin-top:10px; border:1px solid #bbbbbb; position:relative; cursor:pointer;" @click="onFileClick2">
					<img ref="idUserImg2" style="float:left; border:0px solid red;">
					<div ref="idUserNte2" style="position:absolute; width:100%; height:100%; line-height:250px; text-align:center;">{{getLangText(selText2)}}</div>
				</div>
				<div class="NButton DIVNoSelect" style="float:left; width:70px; height:30px; margin-left:25px; margin-top:145px;" @click="onCreateClick2">{{getLangText("生成")}}</div>
				<div style="float:left; width:252px; height:252px; margin-left:25px; margin-top:10px; margin-right:10px; border:1px solid #bbbbbb; position:relative; cursor:pointer;">
					<div ref="idRstImg2" style="float:left; width:100%; height:100%; border:0px solid red;"></div>
					<div ref="idRstNte2" style="position:absolute; width:100%; height:100%; line-height:250px; text-align:center;">{{getLangText("效果图")}}</div>
				</div>
			</div>
		</div>
		<div style="border:0px solid blue;">
			<!--(((保持人物人脸特征不变)))，((年轻，男的帅气，女的漂亮，人物正脸对镜头特写，火山引擎的图像生成大模型里面的《图生图3.0-人像写真》功能创意模式，对人脸进行美颜))高清写实冲浪运动员运动写真，专业冲浪运动员在海浪中冲浪，壮阔海浪翻涌，风浪气势十足，身姿舒展矫健有力且好看，冲浪技术娴熟精湛，人和冲浪板傲然立于浪尖之上，神情自信从容，眼神明亮坚定，充满青春活力与强烈动感，阳光海面波光粼粼璀璨夺目，清澈湛蓝的广阔海洋，晶莹剔透的白色浪花，金色逆光勾勒出完美身体轮廓，电影级光影质感，冷暖光影层次丰富细腻，通透水色与柔和海面反光交织，真实自然的户外水上运动大片，画面干净健康，积极阳光能量，超高清 8K 细节，皮肤质感细腻真实，色彩柔和高级，动态张力十足，竞技美感强烈，氛围感高级大气，构图精致完美;-->
			<textarea ref="idScenePromt" style="float:left; margin-left:10px; margin-top:16px; width:280px; height:400px;" maxlength="2900"></textarea>

			<input type="text" ref="idSceneName" style="float:left; width:280px; height:30px; margin-left:10px; margin-top:15px;" maxlength="30">
			<div style="float:left; width:100%; display:grid; grid-template-columns:1fr auto 1fr;">
				<div></div>
				<div ref="idSaveBtn" class="NButton DIVNoSelect" style="padding-right:10px; margin-top:16px; min-width:120px;" @click="onSaveClick">{{getLangText("保存")}}</div>
				<div></div>
			</div>
		</div>
	</div>
</template>

<script>

import html2canvas from 'html2canvas'

import { SuperGif } from "./libgif"

export default {
	name: 'SourceNew',
	components:{

	},
	data () {
		return {
			prog: 0,
			imgW: 0,   //图片的原始宽度
			imgH: 0,   //图片的原始高度
			taskId: "",         // imageToStyle 返回的用于查询结果的任务ID
			casId: "",          // 当前场景ID
			curServFile1: "",    // 上传服务器返回的照片路径
			curServFile2: "",    // 上传服务器返回的照片路径
			casImg1: "",         // 最新生成的效果图URL1
			casImg2: "",         // 最新生成的效果图URL2
			selText1: "点击选择图片",        // 第一个图片选择文字
			selText2: "点击选择图片",        // 第二个图片选择文字
			prompt1: "",
			prompt2: "",
			curCreateFlag: "",    // 当前生成标志
		}
	},
	mounted: function(){
		console.log( this.$route.query );

		if( this.$route.query.item )
		{
			this.$refs["idSceneName"].value = this.$route.query.item.casName;
			this.$refs["idScenePromt"].value = this.$route.query.item.casPrompt;
			//this.loadRstImg( this.$route.query.item.path );

			this.casId = this.$route.query.item.casId;

			if( this.$route.query.item.casImg1 )
			{
				this.$refs["idRstImg1"].style["background"]  = "url("+this.$route.query.item.casImg1+")";
				this.$refs["idRstImg1"].style["background-size"] = "100% 100%";
				this.$refs["idRstNte1"].style["display"] = "none";
			}
			if( this.$route.query.item.casImg2 )
			{
				this.$refs["idRstImg2"].style["background"]  = "url("+this.$route.query.item.casImg2+")";
				this.$refs["idRstImg2"].style["background-size"] = "100% 100%";
				this.$refs["idRstNte2"].style["display"] = "none";
			}
		}
		else
		{
			this.$refs["idSceneName"].setAttribute("placeholder", LangText("场景名称") );
			this.$refs["idScenePromt"].setAttribute("placeholder", LangText("场景提示词 ( 仅支持中文和英文 )") );
		}

		if( this.$route.query.mode==1 )
		{
			this.selText1 = "点击选择男性图片";
			this.selText2 = "点击选择女性图片";
		}
		else
		{
			this.$refs["idImgPan2"].style["display"] = "none";
		}

		if( this.$route.query.item && this.$route.query.item.casCustId==0 )
		{
			this.$refs["idSaveBtn"].className = "DButton DIVNoSelect";
		}
	},
	computed:{

	},
	methods:{
		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},
		onImgChange: function( e ){
			let file=this.$refs["idImgFile1"];
			let userImg=this.$refs["idUserImg1"];
			let userNte=this.$refs["idUserNte1"];

			if( e.target.getAttribute("id")=="idImgFile2" )
			{
				file    = this.$refs["idImgFile2"];
				userImg = this.$refs["idUserImg2"];
				userNte = this.$refs["idUserNte2"];
			}

			let stW=250;
			let stH=250;
			let image = new Image();
		    let bytes=0;                     //图片的字节数
		    let that=this;
		    image.onload=function(){
		    	that.imgW=image.width;       //图片的原始宽度
		    	that.imgH=image.height;      //图片的原始高度
		    	let wh=that.getZoomSize(stW, stH, that.imgW, that.imgH);     //计算缩放后的规格

		    	userImg.style["width"]  = wh[0]+"px";    //置缩放后的宽度
		    	userImg.style["height"] = wh[1]+"px";    //置缩放后的高度
		    	userImg.style["margin-left"] = (stW-wh[0])/2+"px";
		    	userImg.style["margin-top"]  = (stH-wh[1])/2+"px";
		    	userImg.src = image.src;

				if( e.target.getAttribute("id")=="idImgFile1" )
					 that.curServFile1 = "";     // 重新载入文件后, 需要重新上传
				else that.curServFile2 = "";     // 重新载入文件后, 需要重新上传
		    };

			let filePic = file.files[0];

			if( !filePic ) return;

			bytes = filePic.size;
		    let reader = new FileReader();
		    reader.onload = function (e) {
		        let data = e.target.result;
		        userNte.style["display"] = "none";
		        image.src = data;
		    };
		    reader.readAsDataURL(filePic);
		},
		onFileClick1: function( e ){
			this.$refs["idImgFile1"].files = null;
			this.$refs["idImgFile1"].click();
		},
		onFileClick2: function( ){
			this.$refs["idImgFile2"].files = null;
			this.$refs["idImgFile2"].click();
		},
		onCreateClick1: function(){
			this.curCreateFlag = "img1";
			this.prompt1 = this.$refs["idScenePromt"].value.trim();

			let lines=this.prompt1.split("\n");
			if( lines[0].indexOf("http://")==0 || lines[0].indexOf("https://")==0 )
			{
				this.prompt1 = this.prompt1.replace(lines[0], "" ).trim();
				let body={	custId: this.login.custId,
								cpSerialNo: "CAS"+this.getUIID(),
								imageInput: lines[0],
								prompt: this.prompt1,
								caiLocalYmd: this.getDateInt(),
								caiLocalDt: this.getDTStr(0, 1, 0, 0)
							};

				if( this.$route.query.mode == 1 )    // 单人
				{
					body.width  = 1024;
					body.height = 1024;
					this.doTrade( "POST", ServAddr+"/api/custAiScene/hs/imageToStyle", this.onCreateSceneOK, true, body, null );
				}
				else
				{
					body.width  = 1920;
					body.height = 1920;
					this.doTrade( "POST", ServAddr+"/api/custAiScene/doubao/fuseFace", this.onCreateSceneOK, true, body, null );
				}
			}
			else
			{
				if( this.curServFile1=="" )
				{
					if( this.$refs["idImgFile1"].files[0] )
					{
						this.doUpload( ServAddr+"/api/pub/fileUpload", this.$refs["idImgFile1"].files[0], true, this.onUploadOK, null );
					}
				}
				else  // 文件没有改变时, 不用重新上传, 直接模拟上传成功, 可以用于当生成失败时, 再次生成
				{
					this.onUploadOK( { code:200, body:{filePath:this.curServFile1}} );
				}
			}
		},
		onCreateClick2: function(){
			this.curCreateFlag = "img2";
			this.prompt2 = this.$refs["idScenePromt"].value.trim();

			let lines=this.prompt2.split("\n");
			if( lines[0].indexOf("http://")==0 || lines[0].indexOf("https://")==0 )
			{
				this.prompt2 = this.prompt2.replace(lines[0], "" ).trim();
				let body={	custId: this.login.custId,
								cpSerialNo: "CAS"+this.getUIID(),
								imageInput: lines[0],
								prompt: this.prompt2,
								caiLocalYmd: this.getDateInt(),
								caiLocalDt: this.getDTStr(0, 1, 0, 0)
							};
				if( this.$route.query.mode == 1 )    // 单人
				{
					body.width  = 1024;
					body.height = 1024;
					this.doTrade( "POST", ServAddr+"/api/custAiScene/hs/imageToStyle", this.onCreateSceneOK, true, body, null );
				}
				else
				{
					body.width  = 1920;
					body.height = 1920;
					this.doTrade( "POST", ServAddr+"/api/custAiScene/doubao/fuseFace", this.onCreateSceneOK, true, body, null );
				}
			}
			else
			{
				if( this.curServFile2=="" )
				{
					if( this.$refs["idImgFile2"].files[0] )
					{
						this.doUpload( ServAddr+"/api/pub/fileUpload", this.$refs["idImgFile2"].files[0], true, this.onUploadOK, null );
					}
				}
				else  // 文件没有改变时, 不用重新上传, 直接模拟上传成功, 可以用于当生成失败时, 再次生成
				{
					this.onUploadOK( { code:200, body:{filePath:this.curServFile2}} );
				}
			}
		},
		onUploadOK: function( res ){
			let data=res;
			if( data.code == 200 )   // 上传成功
			{
				let imgFile = data.body.filePath;
				if( this.curCreateFlag == "img1" )
					 this.curServFile1 = imgFile;
				else this.curServFile2 = imgFile;

				console.log( "uploade img : "+imgFile );
				if( this.$route.query.mode == 1 )    // 单人
				{
					let body={	custId: this.login.custId,
								cpSerialNo: "CAS"+this.getUIID(),
								imageInput: imgFile,
								width:1024, height:1024,
								prompt: this.$refs["idScenePromt"].value,
								caiLocalYmd: this.getDateInt(),
								caiLocalDt: this.getDTStr(0, 1, 0, 0)
							};
					this.doTrade( "POST", ServAddr+"/api/custAiScene/hs/imageToStyle", this.onCreateSceneOK, true, body, null );
				}
				else  // 多人场景
				{
					let body={	custId: this.login.custId,
								cpSerialNo: "CAS"+this.getUIID(),
								imageInput: imgFile,
								width:1920, height:1920,
								prompt: this.$refs["idScenePromt"].value,
								caiLocalYmd: this.getDateInt(),
								caiLocalDt: this.getDTStr(0, 1, 0, 0)
							};
					this.doTrade( "POST", ServAddr+"/api/custAiScene/doubao/fuseFace", this.onCreateSceneOK, true, body, null );
				}
			}
			else
			{
				this.appRoot.app.closeDlgRun();
				this.appRoot.app.showDlgTip( 1200, LangText("上传失败"), this.CLR.Err );
			}
		},
		onCreateSceneOK: function( res ){
			let data=res.body;

			if( data.code == 200 )
			{
				if( this.$route.query.mode==1 )   // 单人场景，火山接口是异步
				{
					this.taskId = data.body;
					setTimeout( this.onQrySceneStatus, 10000 );    // 因为生成耗时, 所以第一次查询在10秒后进行
				}
				else   // 多人场景，豆包接口是同步
				{
					this.appRoot.app.closeDlgRun();
					let imgFile=data.body;
					console.log( "create img : "+imgFile );
					if( this.curCreateFlag == "img1" )
					{
						this.casImg1 = imgFile;
						this.$refs["idRstImg1"].style["background"]  = "url("+imgFile+")";
					    this.$refs["idRstImg1"].style["background-size"] = "100% 100%";
						this.$refs["idRstNte1"].style["display"] = "none";
					}
					else
					{
						this.casImg2 = imgFile;
						this.$refs["idRstImg2"].style["background"]  = "url("+imgFile+")";
					    this.$refs["idRstImg2"].style["background-size"] = "100% 100%";
						this.$refs["idRstNte2"].style["display"] = "none";
					}
				}
			}
			else
			{
				this.appRoot.app.closeDlgRun();

				console.log( data );
				this.appRoot.app.closeDlgRun();
				let msg = data.msg.toUpperCase();
				console.log( msg );
				console.log( data.msg.indexOf("SENSITIVE") );
				console.log( data.msg.indexOf("NOT PASS") );
				if( 0<data.msg.indexOf("SENSITIVE") ||       // 豆包-敏感的
				    0<data.msg.indexOf("NOT PASS")       // 火山-内容审核不通过
				   )
				{
					this.appRoot.app.showDlgTip( 2000, LangText("图片包含敏感或违规内容"), this.CLR.War );
				}
				else
				{
					this.appRoot.app.showDlgTip( 2000, LangText("生成失败"), this.CLR.Err );
				}
			}
		},
		onQrySceneStatus:function(){
			let body={ taskId: this.taskId };
			this.doTrade( "POST", ServAddr+"/api/custAiScene/hs/imageToStyleResult", this.onQrySceneStatusOK, true, body, null );
		},
		onQrySceneStatusOK: function( res ){
			let data=res.body;

			if( data.code == 200 )
			{
				if( data.body.status=="in_queue" )  ;    // 任务已提交
				if( data.body.status=="generating" ) ;   // 任务已被消费, 处理中
				if( data.body.status=="not_found" )      // 任务未找到
				{
					this.appRoot.app.closeDlgRun();
					this.appRoot.app.showDlgTip( 1200, LangText("任务不存在"), this.CLR.Err );
					return;
				}
				if( data.body.stauts=="expired" )        // 任务已过期
				{
					this.appRoot.app.closeDlgRun();
					this.appRoot.app.showDlgTip( 1200, LangText("任务超期"), this.CLR.Err );
					return;
				}
				if( data.body.status=="done" )
				{
					this.appRoot.app.closeDlgRun();
					let imgFile=data.body.imageUrl;
					console.log( "create img : "+imgFile );
					if( this.curCreateFlag == "img1" )
					{
						this.casImg1 = imgFile;
						this.$refs["idRstImg1"].style["background"]  = "url("+imgFile+")";
					    this.$refs["idRstImg1"].style["background-size"] = "100% 100%";
						this.$refs["idRstNte1"].style["display"] = "none";
					}
					else
					{
						this.casImg2 = imgFile;
						this.$refs["idRstImg2"].style["background"]  = "url("+imgFile+")";
					    this.$refs["idRstImg2"].style["background-size"] = "100% 100%";
						this.$refs["idRstNte2"].style["display"] = "none";
					}
					return;
				}

				setTimeout( this.onQrySceneStatus, 3000 );    // 3秒钟之后, 重新执行
			}
			else
			{
				console.log( data );
				this.appRoot.app.closeDlgRun();
				this.appRoot.app.showDlgTip( 1200, LangText("生成失败")+" [ "+data.code+" ]", this.CLR.Err );
			}
		},

		/* 保存场景 */
		onSaveClick: function(){
			if( this.$route.query.item && this.$route.query.item.casCustId==0 ) return;

			let prom=this.$refs["idScenePromt"].value.trim();
			prom = prom.replace(/["']/g, "");
			let body={	casName: this.$refs["idSceneName"].value.trim(),
						casSex: this.$route.query.sex,
						casType: this.$route.query.mode,
						reso:"800,800"
				};

			if( this.$route.query.mode==1 )   // 单人场景
			{
				if( this.casImg1 || this.casImg2 )    // 如果生成了效果图
				{
					// 如果两个效果图均生成,且提示词一致，则保存效果图和提示词
					if( this.casImg1 && this.casImg2 )
					{
						if( this.prompt1==this.prompt2 )
						{
							body.casImg1 = this.casImg1;
							body.casImg2 = this.casImg2;
							body.casPrompt = prom;
						}
						else
						{
							this.appRoot.app.showDlgTip( 1200, LangText("效果图与提示词不匹配！"), this.CLR.Err );
							return;
						}
					}
					else
					{
						// 如果只生成了一个效果图且提示词没有变, 则保存效果图
						if( this.casId=="" )   // 添加
						{
							if( this.casImg1 ) body.casImg1 = this.casImg1;
							if( this.casImg2 ) body.casImg2 = this.casImg2;
							body.casPrompt = prom;
						}
						else    // 修改
						{
							if( (this.casImg1 && this.prompt1==this.$route.query.item.casPrompt ) ||
							    (this.casImg2 && this.prompt2==this.$route.query.item.casPrompt ) )
							{
								if( this.casImg1 ) body.casImg1 = this.casImg1;
								if( this.casImg2 ) body.casImg2 = this.casImg2;
							}
							else
							{
								this.appRoot.app.showDlgTip( 1200, LangText("效果图与提示词不匹配！"), this.CLR.Err );
								return;
							}
						}
					}
				}
			}
			else   // 多人场景
			{
				// 生成了效果图, 允许修改提示词和效果, 否则只能修改名称
				if( this.casImg1 )
				{
					body.casImg1 = this.casImg1;
					body.casPrompt = this.prompt1;   // 使用生成时的提示词
				}
			}

			if( this.casId=="" )   // 添加
			{
				if( this.$refs["idSceneName"].value.trim()=="" )
				{
					this.appRoot.app.showDlgTip( 1200, LangText("请输入场景名称"), this.CLR.Err );
					return;
				}
				body.custId = this.login.custId;
				if( this.casImg1=="" && this.casImg2=="" ) body.casPrompt = prom;    // 添加时, 没有效果图时, 保存提示词

				console.log( body );
				this.doTrade( "POST", ServAddr+"/api/custAiScene/add", this.onSaveOK, true, body, null );
			}
			else
			{
				body.casId = this.casId;

				console.log( body );
				this.doTrade( "POST", ServAddr+"/api/custAiScene/edit", this.onSaveOK, true, body, null );
			}
		},
		onSaveOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;

			if( data.code == 200 )
			{
				this.appRoot.app.showDlgTip( 1200, LangText("保存成功"), this.CLR.Suc, this.$parent.onPopWinClose, true );
				return;
			}
			else
			{
				this.appRoot.app.showDlgTip( 1200, LangText("保存失败"), this.CLR.Err );
				return;
			}
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SceneNew.vue?37985928